import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import UserActions from 'actions/UserActionCreators';
import PhoneField from 'components/v2/forms/PhoneField';
import Alert from 'components/ui/Alert';
import { Translation, withTranslation } from 'react-i18next';
import CargomaticInput from 'components/v2/input';
import FormCard from '../../v2/FormCard';
import Badge from '../../v2/Badge';
import CustomerSearch from '../../site/customer-search';
import UserActionCreators from '../../../actions/UserActionCreators';
import UserStore from '../../../stores/UserStore';
import SessionStore from '../../../stores/SessionStore';
import { SHIPPER_SUBSIDIARY_OPTIONS } from 'constants/subsidiary';
const getEmptyState = () => {
    return {
        shipper: {
            company_name: '',
            email: '',
            sales_rep: null,
            can_pay_manually: true,
            first_name: '',
            last_name: '',
            password: '',
            phone: '',
            master_account: {
                name: '',
                id: '',
            },
            subsidiary: '',
        },
        isCustomerManager: SessionStore.isCustomerManagerAdmin(),
        salespeople: [],
    };
};
class RegisterShipper extends Component {
    constructor(props) {
        super(props);
        this.handleUserStoreChange = () => {
            const salespeople = UserStore.getSalesReps().map((rep) => {
                const first_name = (rep.first_name || '').trim();
                const last_name = (rep.last_name || '').trim();
                const name = `${first_name} ${last_name}`.trim();
                return Object.assign(Object.assign({}, rep), { first_name,
                    last_name,
                    name });
            });
            console.log(salespeople);
            this.setState({ salespeople });
        };
        this.handlePhoneChange = (phone) => {
            this.setState((prevState) => {
                return {
                    shipper: Object.assign(Object.assign({}, prevState.shipper), { phone }),
                };
            });
        };
        this.handleChange = (field) => (e) => {
            const { target: { value }, } = e;
            this.setState((prevState) => {
                return {
                    shipper: Object.assign(Object.assign({}, prevState.shipper), { [field]: value }),
                };
            });
        };
        this.handleSelect = (text, shipper) => {
            const { _id: id, name } = shipper;
            this.setState((prevState) => {
                return {
                    shipper: Object.assign(Object.assign({}, prevState.shipper), { master_account: {
                            id,
                            name,
                        } }),
                };
            });
        };
        this.handleRegister = (e) => {
            e.preventDefault();
            const { shipper } = this.state;
            const master_account = shipper.master_account.id
                ? shipper.master_account
                : {};
            UserActionCreators.addCargomaticUser(Object.assign(Object.assign({}, shipper), { master_account }));
            this.setState(getEmptyState());
        };
        this.handleClearMasterAccount = () => {
            this.setState((prevState) => {
                return {
                    shipper: Object.assign(Object.assign({}, prevState.shipper), { master_account: { name: '', id: '' } }),
                };
            });
        };
        this.state = getEmptyState();
    }
    componentDidMount() {
        UserStore.addChangeListener(this.handleUserStoreChange);
        UserActions.getSalespeople();
    }
    componentWillUnmount() {
        UserStore.removeChangeListener(this.handleUserStoreChange);
    }
    render() {
        const { shipper, isCustomerManager } = this.state;
        const { t } = this.props;
        const disabled = isEmpty(shipper.company_name) ||
            isEmpty(shipper.sales_rep) ||
            isEmpty(shipper.email) ||
            isEmpty(shipper.first_name) ||
            isEmpty(shipper.last_name) ||
            isEmpty(shipper.password) ||
            isEmpty(shipper.phone);
        return (React.createElement(FormCard, { actions: () => (React.createElement("button", { disabled: disabled || !isCustomerManager, className: "button button-green", type: "submit", onClick: this.handleRegister }, t('REGISTER_SHIPPER'))) },
            !isCustomerManager && (React.createElement(Alert, { type: "warning" },
                React.createElement(Translation, null, (t) => React.createElement("p", null, t('REQUIRED_CUSTOMER_MANAGER_PRIVILEGES'))))),
            React.createElement("div", { className: "mb-4" },
                React.createElement("h3", { className: "text-lg font-medium text-gray-900 leading-6" }, t('SHIPPER_PROFILE'))),
            React.createElement("div", { className: "grid grid-cols-4 gap-6" },
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('FIRST_NAME')),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "text", placeholder: "John", onChange: this.handleChange('first_name'), value: shipper.first_name, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('LAST_NAME')),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "text", placeholder: "Smith", onChange: this.handleChange('last_name'), value: shipper.last_name, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" },
                        React.createElement("span", null, t('SALES_REP'))),
                    React.createElement("select", { className: "mb-4 form-select", onChange: this.handleChange('sales_rep'), value: shipper.sales_rep || '', disabled: !isCustomerManager },
                        React.createElement("option", { value: "" }, t('SELECT_SALES_REP')),
                        this.state.salespeople.map((rep) => (React.createElement("option", { key: rep.email, value: rep.email },
                            rep.name,
                            " (",
                            rep.email,
                            ")"))))),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" },
                        React.createElement("span", null, t('COMPANY_NAME'))),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "text", placeholder: t('COMPANY_NAME'), onChange: this.handleChange('company_name'), value: shipper.company_name, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('PHONE')),
                    React.createElement(PhoneField, { value: shipper.phone, disabled: !isCustomerManager, onChange: this.handlePhoneChange })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement(CargomaticInput, { className: "block mb-2 form-label", inputClassNames: "w-full mb-4 form-field", type: "text", label: t('PHONE_EXTENSION'), placeholder: t('PHONE_EXTENSION'), onChange: this.handleChange('phone_extension'), value: shipper.phone_extension, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('EMAIL')),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "email", placeholder: "example@cargomatic.com", onChange: this.handleChange('email'), value: shipper.email, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('PASSWORD')),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "password", placeholder: t('PASSWORD'), onChange: this.handleChange('password'), value: shipper.password, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('MASTER_ACCOUNT')),
                    React.createElement("div", { className: "flex items-center" },
                        !shipper.master_account.name && (React.createElement("div", { className: "w-full" },
                            React.createElement(CustomerSearch, { type: "master_shippers", onSelect: this.handleSelect, onRemove: this.handleClearMasterAccount, clearOnSelect: true, disabled: !isCustomerManager }))),
                        shipper.master_account.name && (React.createElement("div", { className: "py-2" },
                            React.createElement(Badge, { color: "brand", withRemove: true, onRemove: this.handleClearMasterAccount }, shipper.master_account.name))))),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" },
                        React.createElement("span", null, t('SUBSIDIARY'))),
                    React.createElement("select", { className: "mb-4 form-select", onChange: this.handleChange('subsidiary'), value: shipper.subsidiary || '', disabled: !isCustomerManager },
                        React.createElement("option", { value: "" }, t('SELECT_SUBSIDIARY')),
                        SHIPPER_SUBSIDIARY_OPTIONS.map((subsidiary) => (React.createElement("option", { key: subsidiary.key, value: subsidiary.value }, t(subsidiary.localizationSlug)))))))));
    }
}
export default withTranslation()(RegisterShipper);
